"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecureRoute = void 0;
var tslib_1 = require("tslib");
/* eslint-disable import/prefer-default-export */
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var react_router_1 = require("react-router");
var cache_1 = require("../../../cache");
var useAuth_1 = require("../../useAuth");
var AuthStatus_1 = require("../../AuthStatus");
var routes_1 = require("../../routes");
var SecureRoute = function (props) {
    var pathname = (0, react_router_1.useLocation)().pathname;
    var authState = (0, useAuth_1.useAuth)().authState;
    if (authState === AuthStatus_1.AuthStatus.LOGGED_OUT) {
        cache_1.fosCache.setItem(cache_1.LOGIN_REQUEST_URI, pathname);
        return react_1.default.createElement(react_router_1.Redirect, { to: routes_1.routes.login });
    }
    return react_1.default.createElement(react_router_1.Route, (0, tslib_1.__assign)({}, props));
};
exports.SecureRoute = SecureRoute;
